import styled from 'styled-components';
import { Card } from 'fiducius-ui';

const ShadowAddCard = styled(Card)`
  box-shadow: ${(p) => p.theme.boxShadowLarge};
`;

export default ShadowAddCard;
